import { Card } from '../ui';

type Props = {
  recommendations?: string[];
};

export function MarketplaceAdvisorCard({ recommendations = [] }: Props) {
  return (
    <Card padding="sm" className="border-brand-200 bg-brand-50/20 dark:border-brand-900 dark:bg-brand-950/20">
      <p className="text-xs font-semibold uppercase tracking-wide text-brand-600">AI Marketplace Advisor</p>
      <ul className="mt-3 space-y-2">
        {recommendations.map((r) => (
          <li key={r} className="flex items-start gap-2 text-sm text-slate-700 dark:text-slate-300">
            <span className="mt-0.5 text-brand-500" aria-hidden="true">✦</span>
            {r}
          </li>
        ))}
      </ul>
    </Card>
  );
}
